// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3C2cn","large":"styles_large__Ux08m"};